<template>
  <div>
    <!-- <form @submit.prevent="save">
      <div>
        <div class="control is-horizontal">
          <div class="control-label">
            <label class="label">Name</label>
          </div>
          <div class="control is-grouped">
            <p class="control is-expanded">
              <input
                v-validate="'required|max:255'"
                :class="{'is-danger': errors.has('name') }"
                name="name"
                v-model="body.name"
                class="input"
                type="text"
                placeholder="Enter name"
              >
              <span
                v-show="errors.has('name')"
                class="help is-danger"
              >{{ errors.first('name') }}</span>
            </p>
          </div>
        </div>

        <div class="control is-horizontal">
          <div class="control-label">
            <label class="label">Permission</label>
          </div>
          <div class="control is-grouped">
            <div
              v-if="profile"
              class="control is-expanded"
            >
              <div
                v-for="(p, k) in data.permission_checklist"
                class="control"
              >
                <fieldset style="border: 1px solid #e0e0e0">
                  <legend style="padding: 5px; margin-left: 5px">
                    <input
                      type="checkbox"
                      :disabled="k==='dashboard'"
                      v-model="listPermission[k].all"
                      @change="onCheckAllInGroup(listPermission[k])"
                    >
                    <label
                      class="is-uppercase"
                      style="font-weight: bold; text-transform: uppercase;"
                    >{{k}}</label>
                  </legend>
                  <div class="control is-grouped">
                    <div
                      class="columns"
                      style="width: 60%;margin: 5px"
                    >
                      <div
                        class="column"
                        v-for="(i, index) in p"
                      >
                        <label class="checkbox">
                          <input
                            :disabled="k==='dashboard'"
                            type="checkbox"
                            v-model="listPermission[k][index].is_active"
                            @change="onCheck(listPermission[k], listPermission[k][index])"
                          >&nbsp{{i.display_name}}

                        </label>
                      </div>
                    </div>
                    <br />
                  </div>
                </fieldset>
              </div>
              <label class="checkbox">
                <input
                  type="checkbox"
                  @change="onCheckAll"
                  v-model="isCheckAll"
                >
                Check All
              </label>
            </div>
          </div>
        </div>

        <div class="control">
          <div class="control">
            <save-button
              :loading="isSaving"
              @click="save"
              :right="true"
            />
            <a
              @click="cancel"
              class="button is-link is-pulled-right"
            >Cancel</a>
          </div>
        </div>
      </div>
    </form> -->

    <!-- ver 2 -->

    <div class="">
      <div class="control is-horizontal">
        <div class="control-label">
          <label class="label">Name</label>
        </div>
        <div class="control is-grouped">
          <p class="control is-expanded">
            <input
              v-model="body.name"
              v-validate="'required|max:255'"
              :class="{ 'is-danger': errors.has('name') }"
              name="name"
              class="input"
              type="text"
              placeholder="Enter name"
            />
            <span v-show="errors.has('name')" class="help is-danger">{{
              errors.first("name")
            }}</span>
          </p>
        </div>
      </div>
      <div class="table-responsive mt-30">
        <table class="table is-bordered is-narrow">
          <thead>
            <tr style="background-color: #e0e0e0">
              <th class="has-text-centered">
                <b style="color: black; line-height: 3rem"> Permissions </b>
              </th>
              <th class="has-text-centered">
                <label class="checkbox" style="color: black">
                  <input
                    v-model="isCheckAll"
                    type="checkbox"
                    @change="onCheckAll"
                  />
                  All Permissions
                </label>
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(p, k) in data.permission_checklist">
              <tr style="background-color: whitesmoke">
                <td>
                  <label
                    class="is-uppercase"
                    style="font-weight: bold; text-transform: uppercase"
                    >{{ k }}</label
                  >
                </td>
                <td class="has-text-centered">
                  <a
                    v-if="k !== 'dashboard'"
                    @click="onCheckAllInGroup(listPermission[k])"
                  >
                    <span v-if="!listPermission[k].all">Select All</span>
                    <span v-else>Deselect All</span>
                  </a>
                </td>
              </tr>
              <tr v-for="(i, index) in p">
                <td>
                  <span class="pl-20">
                    {{ i.display_name }}
                  </span>
                </td>
                <td class="has-text-centered w-30">
                  <vc-switch
                    v-model="listPermission[k][index].is_active"
                    type="success"
                    :class="k === 'dashboard' ? 'is-cursor-not-allowed' : ''"
                    :disabled="k === 'dashboard'"
                    @input="
                      onCheck(listPermission[k], listPermission[k][index])
                    "
                  />
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <!-- <label class="checkbox">
        <input
          type="checkbox"
          @change="onCheckAll"
          v-model="isCheckAll"
        >
        Check All
      </label> -->
      <div class="control">
        <div class="control">
          <save-button :loading="isSaving" :right="true" @click="save" />
          <a class="button is-link is-pulled-right" @click="cancel">Cancel</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import mixins from "components/mixin";
  import { mapGetters } from "vuex";
  export default {
    mixins: [mixins],
    props: {
      data: {
        type: Object,
        default() {
          return {};
        },
      },
      isSaving: Boolean,
    },
    data() {
      return {
        body: {
          name: this.data.name ? this.data.name : "",
          permissions: {},
        },
        permissionRequired: false,
        permissionsSelected: {},
        isCheckAll: false,
        listPermission: null,
      };
    },
    computed: {
      ...mapGetters(["profile"]),
    },
    computed: {},
    created() {
      this.initData();
    },
    methods: {
      onCheck(list, val) {
        let condition = (check) => check.is_active == 0;
        let checkAll = list.some(condition); //kiem tra xem trong 1 group permission dc check het k
        if (!checkAll) {
          list.all = true;
        } else {
          list.all = false;
        }
        this.updateCheckAll();
      },
      onCheckAllInGroup(list) {
        list.all = !list.all;
        list.map((el) => {
          el.is_active = list.all;
          if (el == "all") {
            return;
          }
        });
        this.updateCheckAll();
      },
      onCheckAll() {
        Object.keys(this.listPermission).map((el) => {
          if (el === "dashboard") return;
          this.listPermission[el].all = this.isCheckAll;
          this.listPermission[el].map((child) => {
            child.is_active = this.listPermission[el].all;
            if (child == "all") {
              return;
            }
          });
        });
      },
      updateCheckAll() {
        let check = 0;
        Object.keys(this.listPermission).map((el) => {
          if (!this.listPermission[el].all) {
            check = check + 1;
            return;
          }
        });
        if (check === 0) this.isCheckAll = true;
        else this.isCheckAll = false;
      },
      cancel() {
        this.$emit("cancel");
      },
      save() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            let objResult = {};
            Object.keys(this.listPermission).map((el) => {
              let arrIsActive = [];
              this.listPermission[el].map((child) => {
                if (child.is_active) {
                  arrIsActive.push(child);
                }
              });
              let item = {
                [el]: arrIsActive,
              };
              objResult = { ...objResult, ...item };
              if (this.listPermission[el].all) {
                return;
              }
            });
            this.body.permissions = objResult;
            this.$emit("save", this.body);
          }
        });
      },
      checkAll(data, bool) {},

      initData() {
        this.listPermission = { ...this.data.permission_checklist };
        console.log(
          "data.permission_checklist :>> ",
          this.data.permission_checklist
        );
        Object.keys(this.listPermission).map((el) => {
          let condition = (check) => check.is_active == 0;
          let checkAll = this.listPermission[el].some(condition);

          if (!checkAll) {
            this.listPermission[el].all = true;
          } else {
            this.listPermission[el].all = false;
          }
          this.listPermission[el].map((child) => {
            child.is_active = child.is_active == 1 ? true : false;
          });
        });
        this.updateCheckAll();
      },
    },
  };
</script>

<style scoped></style>
